export default __webpack_public_path__ + "static/media/PartyIcon-white.b6b02543.svg";